import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { REQUIRED_ROLES } from "../config/authConfig";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, userRoles } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  console.log("role access details:", {
    requiredRoles: REQUIRED_ROLES,
    userRoles,
  });

  // block access if user does not have at least one required role
  if (!userRoles.some((role) => REQUIRED_ROLES.includes(role))) {
    return <h3>Access Denied: You do not have the required role.</h3>;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
